import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"items":_vm.items,"hide-details":"auto","outlined":"","label":_vm.$t('Provider'),"clearable":""},model:{value:(_vm.providers),callback:function ($$v) {_vm.providers=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"providers"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }